package net.frozenbit.games.soundgame.components

import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.unit.sp

@Composable
fun JoinCode(
    joinCode: String,
    modifier: Modifier = Modifier,
) {
    Text(
        joinCode,
        modifier = modifier,
        fontFamily = FontFamily.Monospace,
        fontSize = 64.sp,
        style = TextStyle(
            letterSpacing = 8.sp,
        ),
    )
}